<template>
  <div class="flex vertical full-height">
    <div class="scrollable-container main">
      <BackNavigationItem :backNavigation="{ title: 'Zurück', path: '/profile' }" />
      <ReleaseNotesDocument />
    </div>
  </div>
</template>

<script>

import {
  ReleaseNotesDocument
} from "@profineberater/configurator-clientlib"
import BackNavigationItem from "../components/ui/BackNavigationItem.vue";

export default {
  name: 'ReleaseNotesPage',
  components: {
    ReleaseNotesDocument,
    BackNavigationItem
  },
}
</script>
